import { useLegalEntityStore } from '@/store/LegalEntityStore'
import { authService } from '@/services/auth.service'
import { legacyUrl } from '@/utils/environment'

export const gotoLegacyApp = (app: string, nav: number | undefined = undefined) => {
  if (app === 'pis') {
    console.log('Navigate to pis')
    gotoLegacy('dbp', 365)
  } else {
    console.log(`Navigate to ${app}`)
    gotoLegacy(app, nav)
  }
}

export const gotoLegacy = (app: string, nav: number | undefined) => {
  const myUrl: string = createLegacyLoginUrl(app, nav)
  console.log('open legacy url', myUrl)
  window.open(myUrl, '_blank')
}

/** this is the computed baselink into the legay system eg:`https://legacy.dbmilch.ch/dbp/index.cfm?`
 *  this does not include the jwt token
 * */
export function createLegacyUrl(app: string, nav: number | undefined): string {
  let myUrl: string = legacyUrl + app + '/index.cfm?'
  if (nav) myUrl += `Nav=${nav}&`
  console.log('create legacy url', myUrl)
  return myUrl
}

/** including the jwt token, prebuild for the db2020 home links */
export function createLegacyLoginUrl(app: string, nav: number | undefined): string {
  const legalEntityStore = useLegalEntityStore()
  return createLegacyUrl(app, nav) + 'action=login&domainID=' + legalEntityStore.getSelectedPersonId + '&jwt=' + authService.loadedUser?.access_token + '&'
}
